import React from 'react';
import LoadingMask from 'partial/OfferManager/LoadingMask';
import FactorTipsOffersModuleView from './PaymentHistoryOffersModuleView';
import { useConfig } from 'hook/config.hook';
import { useSelector } from 'react-redux';
import { FACTOR_ENUMS } from 'pages/RedesignDashboard/constants';
import { getViewModuleTrackingAttributes } from 'helpers/tracking.helpers';
import { useSeenModulePixel } from 'hook/helper.hook';
import { CreditBureauProviderCamelCase } from 'pages/QuarterlyReport/constants';
import * as Constants from 'types/mrph.pageName.constants';
import { FACTOR_TIPS_OFFERS } from 'types/morph.pagePosition.constants';

export const FactorTipsOffersModuleController = props => {
  const { offers, eventHandler, modulePosition } = props;
  const { CREDIT_AGE, CREDIT_USAGE, PAYMENT_HISTORY } = FACTOR_ENUMS;
  const {
    selectedFactor,
    selectedFactorGrade,
    creditUsageContainer,
    paymentHistoryContainer,
    creditAgeContainer,
    selectedBureau,
  } = useSelector(state => ({
    selectedFactor: state?.score1b3bFactorDial?.factor?.selectedFactor,
    selectedFactorGrade:
      state?.score1b3bFactorDial?.factor?.selectedFactorGrade,
    creditUsageContainer: state?.creditUsageContainer?.creditUsageContainer,
    creditAgeContainer: state?.creditAgeContainer?.creditAgeContainer,
    paymentHistoryContainer:
      state?.paymentHistoryContainer?.paymentHistoryContainer,
    selectedBureau: state?.score1b3bFactorDial?.bureau?.selectedBureau,
  }));
  const { config } = useConfig();

  const tips =
    config?.factorModulesTips?.[selectedFactor]?.[
      selectedFactorGrade || 'DEFAULT'
    ];
  const loading = props.globalLoadingFlag;

  if (selectedFactor === CREDIT_AGE) {
    const module = creditAgeContainer?.modules?.find(
      module => module.module === 'CREDIT_AGE_SUMMARY',
    );

    const oldestTradeLine =
      module?.additionalData?.creditAgeSummary?.oldestTradeline?.creditor;

    tips?.forEach(tip => {
      tip.body = tip?.body.replace(
        '[credit_age_oldest_tradeline]',
        oldestTradeLine || 'N/A',
      );
    });
  }

  if (selectedFactor === CREDIT_USAGE) {
    const module = creditUsageContainer?.modules?.find(
      module => module.module === 'CREDIT_USAGE_SUMMARY',
    );
    const creditUsageSummaryCreditLimit =
      module?.additionalData?.creditUsageSummary?.totalCreditLimit;
    let percent = 0.3;
    if (['A', 'B'].includes(selectedFactorGrade)) {
      percent = 0.1;
    }
    const balanceToReduce = creditUsageSummaryCreditLimit * percent;

    tips?.forEach(tip => {
      tip.body = tip?.body.replace(
        '[credit_usage_balance_to_reduce]',
        balanceToReduce?.toLocaleString(),
      );
    });
  }

  if (selectedFactor === PAYMENT_HISTORY) {
    const module = paymentHistoryContainer?.modules?.find(
      module => module.module === 'PAYMENT_HISTORY_SUMMARY',
    );
    const negativeMarks =
      module?.additionalData?.paymentHistorySummary
        ?.totalNegativeMarkAccountCount;
    tips?.forEach(tip => {
      tip.body = tip?.body.replace('[negative_marks]', negativeMarks);
    });
  }
  const trackingAtr = getViewModuleTrackingAttributes({
    pagePosition:
      FACTOR_TIPS_OFFERS +
      ' ' +
      CreditBureauProviderCamelCase[selectedBureau] +
      ' ' +
      Constants[selectedFactor],
    modulePosition: modulePosition,
  });
  const seenPixel = useSeenModulePixel(trackingAtr);

  if (loading) {
    return <LoadingMask />;
  } else
    return (
      <FactorTipsOffersModuleView
        offers={offers}
        eventHandler={eventHandler}
        tips={tips}
        seenPixel={seenPixel}
        modulePosition={modulePosition}
        pagePosition={FACTOR_TIPS_OFFERS}
        creditCardDebt={props?.creditInfo?.debtAnalysis?.creditCardDebt}
      />
    );
};
